import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvironmentService } from 'experian-shared-frontend';
import { SessionManager } from 'experian-authentication-frontend-components';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    public jwtHelper: JwtHelperService,
    public environmentService: EnvironmentService,
    private readonly sesionManager: SessionManager
  ) {}

  public isAuthenticated(token): boolean {
    return !this.jwtHelper.isTokenExpired(token);
  }

  public get accessToken(): string {
    const accessToken = this.sesionManager.accessToken || null;
    return accessToken || localStorage.getItem('app-identity-token');
  }

  public get isLoggedIn(): boolean {
    return !!this.accessToken;
  }

}
